import tools from '@/components/common/tools'
import tree from '@/components/common/tree'

// 菜单树
let moduleTree = new tree.TreeCreate(function (item) {
  for (let key in item) {
    if (item.hasOwnProperty(key)) {
      this[key] = item[key]
    }
  }
}, {
  FId: 'MoFacode',
  Id: 'MoCode'
})

// 快捷菜单
export const quickNavModuleData = state => {
  return state.user.memberPower.filter(item => item.IsLeaf === 1 && item.MoType === 0)
}

// 侧边菜单
export const sideModuleData = state => {
  let data = tools.getModel(state.user.memberPower)
  // 首页
  data.unshift({
    MoFacode: '0',
    MoCode: '1',
    MoName: 'Index',
    MoUrl: '/Welcome',
    MoLogo: 'fa-gg',
    MoSort: 10000,
    MoType: 0,
    IsLeaf: 1,
    MoState: 1
  })
  // 个人信息页面
  data.unshift({
    MoFacode: '0',
    MoCode: '2',
    MoName: 'Member Manage',
    MoUrl: '/AdminUserInfo',
    MoLogo: 'fa-gg',
    MoSort: 10001,
    MoType: 1,
    IsLeaf: 1,
    MoState: 1
  })
  moduleTree.create(data)
  return moduleTree.getTreeData()
}



// WEBPACK FOOTER //
// ./src/store/common/getters.js